// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseButton_closeButton__OU2yp","iconContainer":"CloseButton_iconContainer__MWi6s"};